import { Cookies } from 'react-cookie';
import JwtAuthentication from '../../helpers/jwtAuthentication';

const cookies = new Cookies();

const localToken = JwtAuthentication.checkExpirity(cookies.get('id_token'));

const initState = {
	isFetching: false,
	isAuthenticated: !!localToken.token,
	isLoading: false
};

export default function auth(state = initState) {
	return state;
}
